import { render } from "./PaymentSuccess.vue?vue&type=template&id=f70b39d6&scoped=true&ts=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=ts"
export * from "./PaymentSuccess.vue?vue&type=script&lang=ts"

import "./PaymentSuccess.vue?vue&type=style&index=0&id=f70b39d6&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f70b39d6"]])

export default __exports__